import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Header } from 'components/Header'
import { Layout } from 'components/Layout'
import { Footer } from 'components/Footer'
import { RecipeDetailHero } from './components/RecipeDetailHero'
import { RecipeDetailBenefits } from './components/RecipeDetailBenefits'
import { RecipeDetailIngredients } from './components/RecipeDetailIngredients'
import { Explore } from './components/Explore'
import { CtaFooter } from 'features/Home/components/CtaFooter'
import { RecipeRoot, BreadCrumbWrapper } from './FreezeDriedRecipeDetail.styles'
import { WhatYouNeed } from 'features/ECommerce/screens/AllProducts/components/WhatYouNeed'
import { BreadCrumbs } from 'components/BreadCrumbs'
import { TranslationKeys } from 'locales/translationKeys'
import { FreezeDriedProteins } from 'models/Pet'
import { freezeDriedRecipes } from './freezeDriedRecipes'

type FreezeDriedRecipeDetailProps = {
  protein: FreezeDriedProteins
}

export const FreezeDriedRecipeDetail = ({ protein }: FreezeDriedRecipeDetailProps) => {
  const { t } = useTranslation()

  const header = <Header />

  const recipe = freezeDriedRecipes[protein]

  const { hero, benefits } = recipe

  const crumbs: TranslationKeys[] = [
    'recipes:freeze-dried.breadcrumbs.freeze-dried-raw-recipes',
    recipe.breadcrumb,
  ]

  return (
    <RecipeRoot>
      <Layout ctaLabel="recipes:freeze-dried.mobile-cta-label" header={header}>
        <BreadCrumbWrapper>
          <BreadCrumbs crumbs={crumbs} />
        </BreadCrumbWrapper>
        <RecipeDetailHero
          imageSrc={hero.imageSrc}
          imageAlt={hero.imageAlt}
          title={hero.title}
          features={hero.features}
          description={hero.description}
          infoList={hero.infoList}
          nutrition={hero.nutrition}
          proteinPricing={hero.proteinPricing}
        />
        <RecipeDetailBenefits
          title={benefits.title}
          list={benefits.list}
          imageSrc={benefits.imageSrc}
          imageAlt={benefits.imageAlt}
        />
        <RecipeDetailIngredients
          title="recipes:ingredients-title"
          rows={recipe.ingredients}
          condensed
        />
        <Explore image={recipe.alternativeImage} recipe={protein} />
        <WhatYouNeed howItWorks />
        <CtaFooter title="recipes:freeze-dried.footer-cta.title" />
        <Footer />
      </Layout>
    </RecipeRoot>
  )
}

FreezeDriedRecipeDetail.displayName = 'FreezeDriedRecipeDetail'
